import React from 'react';

const Kansas = () => {
  return (
    <div>
      
    </div>
  );
}

export default Kansas;
